import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { useFieldAttributes } from "../../../services/field-attributes.js";
import { getDatePartsErrors } from "../../../ui/date-field/date-field-utils.js";
import { FieldDescriptionWUT } from "../../../ui/field-description/field-description-wut.js";
import { FieldErrorWUT } from "../../../ui/field-error/field-error-wut.js";
import { FieldLabelWUT } from "../../../ui/field-label/field-label-wut.js";
import { Widget } from "../../../ui/widget/widget.js";
import { DateFieldWUT } from "../../../ui/date-field/date-field-wut.js";
const ContactsBirthdateWUT = (props) => {
  const {
    id,
    description,
    target,
    value,
    onChange,
    error,
    hasError = false,
    errorMessage,
    hideLabel,
    required,
    label,
    requiredIndicatorType,
    requiredIndicatorPlacement,
    FieldLayout,
    widgetHtml,
    widgetEnabled
  } = props;
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  const hidePlaceholder = props.hidePlaceholder ?? props.placeholder === "none";
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        DateFieldWUT,
        {
          ...props,
          errors: getDatePartsErrors(hasError, value ?? ""),
          hidePlaceholder,
          inputId,
          ariaLabelledBy: labelId,
          value,
          ariaDescribedBy
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId })
      ] })
    }
  );
};
export {
  ContactsBirthdateWUT
};
//# sourceMappingURL=contacts-birthdate-wut.js.map
